import { MouseEventHandler } from "react";
import styles from "./MiniButton.module.css";

/**
 * 사이드시트용 미니 버튼 설정
 * @interface
 * @prop type string 버튼 종류 -> MiniButtonType으로 설정
 * @prop onclick (optional) {@link MouseEventHandler}<{@link HTMLElement}> 버튼 클릭 이벤트핸들러 함수
 */
export interface ButtonProps {
    label: string;
    type?: string;
    onClick?: MouseEventHandler<HTMLElement>;
}

// export const MiniButtonType = {
//     BLUE: "blue",
//     GRAY: "gray",
//     RED: "red",
//     DISABLED: "disabled",
// };

export const MiniButtonType = {
    BLUE: "blue",
    GRAY: "gray",
    RED: "red",
    DISABLED: "disabled",
};

/**
 * 공통 미니 버튼 컴포넌트
 * @author smyun, mjkang
 * @since 2024-08-23
 * @param props {@link ButtonProps}
 * @returns MiniButton
 */

const MiniButton = (props: ButtonProps) => {
    // 25.08.29 | Kim Young Jun | DISABLED 타입일 때 버튼 클릭 방지 및 disabled 속성 적용
    const color = props.type && styles[props.type] ? styles[props.type] : "";
    const isDisabled = typeof props.type === "string" && props.type.toLowerCase() === "disabled";

    return (
        <button
            className={`${styles.base} ${color}`}
            onClick={isDisabled ? undefined : props.onClick}
            disabled={isDisabled}
            aria-disabled={isDisabled}
        >
            <span>{props.label}</span>
        </button>
    );
};

export default MiniButton;
